<template>
  <div
    class="notification-dropdown-component"
    :class="{ 'notification-dropdown-component--min': verticalNavMenuItemsMin }">
    <!-- NOTIFICATIONS -->
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >
      <feather-icon
        icon="BellIcon"
        class="cursor-pointer notification-dropdown-component__icon"
        :class="{
          'notification-dropdown-component--min__icon': verticalNavMenuItemsMin,
          'sm:mr-6': verticalNavMenuItemsMin
        }"
        :badge="unreadNotificationsBadge"
      />

      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
      >

        <div class="notification-top text-center p-5 bg-primary text-white">
          <h3 class="text-white">
            Notificações
          </h3>
        </div>

        <VuePerfectScrollbar
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0"
          :settings="settings"
          :key="$vs.rtl"
        >
          <ul class="bordered-items" v-if="unreadNotifications.length > 0">
            <li 
              v-for="ntf in unreadNotifications"
              :key="ntf.id"
              class="flex justify-between px-4 py-4 cursor-pointer"
            >
              <div class="flex items-start">
                <div 
                  class="mx-2"
                  style="width: 325px !important;"
                  @click="openNotificationModal(ntf)"
                >
                  <div class="truncate">
                    <span class="font-medium block notification-title text-primary">
                      {{ ntf.title }}
                    </span>
                  </div>
                  
                  <div class="truncate">
                    <small>
                      {{ ntf.text }}
                    </small>
                  </div>

                  <div class="truncate text-right">
                    <small class="mt-1 whitespace-no-wrap">
                      {{ elapsedTime(ntf.created_at) }}
                    </small>
                  </div>
                </div>
              </div>
            </li>
          </ul>

          <p v-else class="p-3 text-center opacity-75">
            Nenhuma notificação
          </p>
        </VuePerfectScrollbar>

        <!-- <div class="
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          font-semibold
          text-center
          border
          border-b-0
          border-l-0
          border-r-0
          border-solid
          d-theme-border-grey-light
          cursor-pointer">
          <span>Carregar Mais</span>
        </div> -->
      </vs-dropdown-menu>
    </vs-dropdown>

    <vs-popup :title="notificationModalData.title" :active.sync="notificationModalIsActive" :button-close-hidden="true" style="z-index: 1000000">
      <div>
        <p class="text-body" v-html="formatText(notificationModalData.text)"></p>
      </div>

      <vs-divider class="mb-4"/>

      <div class="flex flex-wrap float-right">

        <div class="mr-6">
          <vs-button @click.prevent="readNotification()" type="flat" color="primary"> Marcar Como Lida </vs-button>
        </div>
        <div>
          <vs-button @click.prevent="notificationModalIsActive=false" color="primary"> Voltar </vs-button>
        </div>

      </div>

    </vs-popup>
    
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    verticalNavMenuItemsMin: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      notificationModalIsActive: false,
      notificationModalData: {
        title: '',
        text: '',
        id: null
      }
    }
  },
  computed: {
    unreadNotificationsBadge() {
      return this.unreadNotifications.length < 10 ? this.unreadNotifications.length : '9+'
    },
    unreadNotifications() {
      return this.$store.state.userNotification
        ? this.$store.state.userNotification.userNotifications
        : []
    }
  },
  methods: {
    openNotificationModal(notification) {
      this.notificationModalIsActive = true;
      this.notificationModalData     = {
        text: notification.text.trim(),
        title: notification.title,
        id: notification.id
      };
    },
    async readNotification() {
      await this.$store.dispatch("userNotification/read", this.notificationModalData.id)
      .then( () => {
        this.notificationModalIsActive = false;
        this.notificationModalData     = {
          title: '',
          text: '',
          id: null
        };
      });
    },
    formatText(text) {
      if (text) {
        return text.replace(/\n/g, '<br>');
      }
      return '';
    },
    elapsedTime(startTime) {
      let x        = new Date(startTime)
      let now      = new Date()
      var timeDiff = now - x
      timeDiff    /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      var hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      var days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      var years   = timeDiff

      if (years > 0) {
        return years + (years > 1 ? ' anos ' : ' ano ') + 'atrás'
      } else if (days > 0) {
        return days + (days > 1 ? ' dias ' : ' dia ') + 'atrás'
      } else if (hours > 0) {
        return hours + (hours > 1 ? ' horas ' : ' hora ') + 'atrás'
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? ' minutos ' : ' minuto ') + 'atrás'
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' segundos atrás' : 'agora mesmo')
      }

      return 'agora mesmo'
    }
  }
}

</script>

<style lang="scss">
.notification-dropdown-component {
  .vs-dropdown--custom.vs-dropdown--menu {
    min-height: 140px !important;
    min-width: 300px !important;
    > section {
      min-height: 140px !important;
    }
  }

  padding: 0;

  .feather-icon {
    margin-right: 0 !important;
  }

  &__icon {
    width: 15px;
    height: 15px;
  }

  &--min {
    padding: 10px 15px;

    &__icon {
      width: 16px;
      height: 16px;
    }
  }
}

.text-body {
  padding: 1rem;
  -webkit-transition: all .23s ease .1s;
  transition: all .23s ease .1s;
  white-space: pre-line;
  font-size: 1rem;
  img {
    max-width: 100% !important;
  }
}

.vs-dialog-text {
  white-space: pre-line;
}

.vs-button-filled {
  color: #fff !important;
}

.notification-dropdown {
  .truncate {
    width: 95%;
  }

  &.con-vs-dropdown--menu {
    width: auto !important;
    max-width: 365px !important;
  }
}
</style>
